import appConfig from "@/config/apiClientConfig";
import axios from "axios";

const ApiClient = axios.create();

let on401Callback: (() => void) | null = null;

export const setOn401Callback = (callback: () => void) => {
  on401Callback = callback;
};

ApiClient.interceptors.request.use(
  (config) => {
    config.baseURL = appConfig.apiBaseUrl();
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Request interceptor error:", error);
    return Promise.reject(error);
  },
);

ApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      if (on401Callback) {
        on401Callback();
      }
    }
    return Promise.reject(error);
  }
);

export default ApiClient;
